import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.6 15.043l-2.822 -2.821l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.188 1.188","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconPointerMinus = createReactComponent('outline', 'pointer-minus', 'PointerMinus', __iconNode);

export default IconPointerMinus;